// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const darumaka_galar: PokeData = {
  "id": 10176,
  "name": "darumaka-galar",
  "height": 7,
  "weight": 400,
  "base_experience": 63,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "ice-punch",
    "headbutt",
    "tackle",
    "thrash",
    "bite",
    "blizzard",
    "powder-snow",
    "belly-drum",
    "uproar",
    "taunt",
    "superpower",
    "avalanche",
    "ice-fang",
    "work-up"
  ],
  "moves": [
    "ice-punch",
    "headbutt",
    "tackle",
    "bite",
    "blizzard",
    "superpower",
    "avalanche",
    "ice-fang",
    "ice-shard",
    "aurora-veil",
    "sheer-cold",
    "hailstorm",
    "ice-wave"
  ],
  "evolution_chain": {
    "id": 282,
    "item": null,
    "species": [
      {
        "name": "darumaka",
        "order": 555,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "darmanitan",
        "order": 556,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 554,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 100,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
